import { api } from "@/lib/api";
import type { InAppNotification, UnreadCount } from "@/lib/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useIsTabVisible } from "./use-tab-visible";

export function useNotifications(unreadOnly = false) {
  return useQuery({
    queryKey: ["notifications", { unreadOnly }],
    queryFn: () =>
      api<InAppNotification[]>(`/api/ops/v1/notifications${unreadOnly ? "?unread=true" : ""}`),
  });
}

export function useUnreadCount() {
  const isVisible = useIsTabVisible();
  return useQuery({
    queryKey: ["notifications", "unread-count"],
    queryFn: () => api<UnreadCount>("/api/ops/v1/notifications/unread-count"),
    refetchInterval: isVisible ? 30_000 : false,
  });
}

export function useMarkNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (ids?: number[]) =>
      api("/api/ops/v1/notifications/read", {
        method: "POST",
        body: JSON.stringify({ ids: ids ?? [] }),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
}
